import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Inventorization } from '../models';

@Injectable({ providedIn: 'root' })
export class InventorizationService extends EntityCollectionServiceBase<Inventorization> {
    [name: string]: any;
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('Inventorization', serviceElementsFactory);
    }
}
